// extracted by mini-css-extract-plugin
module.exports = {"header":"Z28neiw5","title":"xsvYyhpu","wrapper":"A3eU8b1n","image":"rEmun2eI","loadingWrapper":"hdU9CJaj"};